import { Component, OnInit } from '@angular/core';

export interface NonTeachingMember {
  name: string;
  designation: string;
  phone: string;
  qualification: string;
  department: string;
  workingSince: string;
  image?: string;
}

@Component({
  selector: 'app-non-teaching-staff',
  templateUrl: './non-teaching.component.html',
  styleUrls: ['./non-teaching.component.scss']
})
export class NonTeachingStaffComponent implements OnInit {
  staffList: NonTeachingMember[] = [
    {
      name: "Ms. Rajesh Rani",
      designation: "Lab Assistant",
      phone: "9817692590",
      qualification: "M.A(HINDI)",
      department: "Department of Home Science",
      workingSince: "2000",
      image: "assets/img/faculty/non-teaching/rajesh_rani.png"
    },
    // {
    //   name: "Ms. Suman Rani",
    //   designation: "Office Supervisor",
    //   phone: "8199011229",
    //   qualification: "M.TECH(C.S)",
    //   department: "Administration",
    //   workingSince: "2016",
    //   image: "assets/img/faculty/non-teaching/suman_rani.png"
    // },
    {
      name: "Ms. Jasbir Kaur",
      designation: "Assistant Librarian",
      phone: "8683814405",
      qualification: "M.A(PUNJABI), M.LIB",
      department: "Library",
      workingSince: "2005",
      image: "assets/img/faculty/non-teaching/jasbir_kaur.png"
    },
    {
      name: "Ms. Varsha Rani",
      designation: "Accountant",
      phone: "9466228732",
      qualification: "M.COM",
      department: "Accounts Department",
      workingSince: "2015",
      image: "assets/img/faculty/non-teaching/varsha_rani.png"
    },
    {
      name: "Ms. Anita Rani",
      designation: "Office Assistant",
      phone: "9255991101",
      qualification: "M.A(PUB AD)",
      department: "Administration",
      workingSince: "2010",
      image: "assets/img/faculty/non-teaching/anita_rani.png"
    },
    {
      name: "Ms. Preeti",
      designation: "Lab Assistant",
      phone: "8607331499",
      qualification: "B.ED, PGDCA",
      department: "Computer Lab",
      workingSince: "2010",
      image: "assets/img/faculty/non-teaching/preeti.png"
    },
    {
      name: "Ms. Raminder Kaur",
      designation: "Office Assistant",
      phone: "8295121499",
      qualification: "M.A(HISTORY)",
      department: "Administration",
      workingSince: "2011",
      image: "assets/img/faculty/non-teaching/raminder_kaur.png"
    },
    // {
    //   name: "Ms. Manish Kaswan",
    //   designation: "Music Teacher",
    //   phone: "9466613388",
    //   qualification: "M.A(ENG)",
    //   department: "Music Department",
    //   workingSince: "2014",
    //   image: "assets/img/faculty/non-teaching/manish_kaswan.png"
    // },
    {
      name: "Ms. Hardeep Kaur",
      designation: "Lab Assistant",
      phone: "7419197292",
      qualification: "M.A(ENG)",
      department: "Department of Geography",
      workingSince: "2014",
      image: "assets/img/faculty/non-teaching/hardeep_kaur.png"
    },
    // {
    //   name: "Ms. Manisha",
    //   designation: "Lab Assistant",
    //   phone: "8168480098",
    //   qualification: "BCA, MCA(PURSUING)",
    //   department: "Computer Lab",
    //   workingSince: "2022",
    //   image: "assets/img/faculty/non-teaching/manisha.png"
    // },
    {
      name: "Ms. Gurmeet",
      designation: "Lab Assistant",
      phone: "8295528660",
      qualification: "M.A, B.ED, PHOTOSHOP",
      department: "Department of Physical Education",
      workingSince: "2022",
      image: "assets/img/faculty/non-teaching/gurmeet.png"
    },
    // {
    //   name: "Ms. Jyoti",
    //   designation: "Receptionist",
    //   phone: "7988577217",
    //   qualification: "M.COM",
    //   department: "Reception",
    //   workingSince: "2023",
    //   image: "assets/img/faculty/non-teaching/jyoti.png"
    // },
    {
      name: "Ms. Sarabjeet Kaur",
      designation: "Assistant Library",
      phone: "9814364079",
      qualification: "M.A, B.ED, M.LIB, DIPLOMA IN (COMP SC., COMPUTER APPLICATIONS)",
      department: "Library",
      workingSince: "2023",
      image: "assets/img/faculty/non-teaching/sarabjeet_kaur.png"
    },
    // {
    //   name: "Ms. Ekta",
    //   designation: "Cultural Co-ordinator",
    //   phone: "8307012432",
    //   qualification: "B.SC MEDICAL, M.SC BOTANY, B.A(KATHAK DANCE), B.ED",
    //   department: "Cultural Activities Department",
    //   workingSince: "2023",
    //   image: "assets/img/faculty/non-teaching/ekta.png"
    // },
    {
      name: "Ms. Sonam",
      designation: "Office Assistant",
      phone: "8295319018",
      qualification: "BCA, MCA, B.ED",
      department: "Administration",
      workingSince: "2024",
      image: "assets/img/faculty/non-teaching/sonam.png"
    },
    {
      name: "Ms. Sneha",
      designation: "ERP Operator",
      phone: "",
      qualification: "BCA",
      department: "Administration",
      workingSince: "2026",
      image: "assets/img/faculty/non-teaching/sneha.jpeg"
    }
  ];

  selectedStaff: NonTeachingMember | null = null;
  showModal = false;

  constructor() { }

  ngOnInit(): void { }

  getInitials(name: string): string {
    if (!name) return '';
    let cleanName = name.replace(/^(Dr\.|Ms\.|Mr\.|Mrs\.)\s+/i, '');
    let parts = cleanName.split(/\s+/).filter(p => p.length > 0);
    if (parts.length === 1) {
      return parts[0].substring(0, 2).toUpperCase();
    }
    return (parts[0][0] + (parts[1][0] || '')).toUpperCase();
  }

  openDetails(staff: NonTeachingMember) {
    this.selectedStaff = staff;
    this.showModal = true;
    document.body.style.overflow = 'hidden';
  }

  closeModal() {
    this.showModal = false;
    this.selectedStaff = null;
    document.body.style.overflow = 'auto';
  }
}
